import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byId: {},
    filteredById: {},
    loading: false
});

export default (state = getInitialState(), action) => {
    let newById;
    switch (action.type) {
        case ACTIONS.GET_MANY_WELCOME_ASSETS_START: {
            return {
                ...state,
                loading: true
            };
        }
        case ACTIONS.GET_MANY_WELCOME_ASSETS: {
            newById = {
                ...state.byId
            };

            action.payload.welcomeAssets.forEach((welcomeAsset) => {
                if (welcomeAsset._id in newById) {
                    newById[welcomeAsset._id] = {
                        ...newById[welcomeAsset._id],
                        ...welcomeAsset
                    };
                } else {
                    newById[welcomeAsset._id] = welcomeAsset;
                }
            });

            return {
                ...state,
                byId: newById,
                loading: false
            };
        }

        case ACTIONS.GET_WELCOME_ASSET:
        case ACTIONS.PUT_WELCOME_ASSET_SUCCESS:
        case ACTIONS.POST_WELCOME_ASSET_SUCCESS: {
            const { welcomeAsset } = action.payload;
            newById = {
                ...state.byId
            };

            if (welcomeAsset._id in newById) {
                newById[welcomeAsset._id] = {
                    ...newById[welcomeAsset._id],
                    ...welcomeAsset
                };
            } else {
                newById[welcomeAsset._id] = welcomeAsset;
            }
            return {
                ...state,
                byId: newById,
                loading: false
            };
        }

        default:
            return state;
    }
};
